import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getLogRequestResponse = createAsyncThunk(
  "app/getLogRequestResponse",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/log/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);
